	<div class=" boxed-container" [ngClass]="showMenuComponent ?'body-wrap-coss':'body-wrap'">
		<!--HEADER START HERE-->
		<header class="site-header">
			<div class="header-shape header-shape-1">
				<svg width="337" height="222" viewBox="0 0 337 222" xmlns="http://www.w3.org/2000/svg">
					<defs>
						<linearGradient x1="50%" y1="55.434%" x2="50%" y2="0%" id="header-shape-1">
							<stop stop-color="#E0E1FE" stop-opacity="0" offset="0%" />
							<stop stop-color="#E0E1FE" offset="100%" /> </linearGradient>
					</defs>
					<path d="M1103.21 0H1440v400h-400c145.927-118.557 166.997-251.89 63.21-400z" transform="translate(-1103)" fill="url(#header-shape-1)" fill-rule="evenodd" /> </svg>
			</div>
			<div class="header-shape header-shape-2">
				<svg width="128" height="128" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">
					<defs>
						<linearGradient x1="93.05%" y1="19.767%" x2="15.034%" y2="85.765%" id="header-shape-2">
							<stop stop-color="#FF3058" offset="0%" />
							<stop stop-color="#FF6381" offset="100%" /> </linearGradient>
					</defs>
					<circle class="anime-element fadeup-animation" cx="64" cy="64" r="64" fill="url(#header-shape-2)" fill-rule="evenodd" /> </svg>
			</div>
			<div class="container">
				<div class="site-header-inner">
					<div class="brand header-brand">
						<h1 class="m-0"><a href="#"><img src="./assets/images/main-logo.svg"></a></h1>
					</div>
					<div class="main-menu">
						<div class="menu__list">
							<ul>
								<li><a href="#">About</a></li>
							<li><a href="#">Contact</a></li>
							</ul>
							
						</div>
						<a href="" class="signCta">LOGIN / SIGNUP</a>
					</div>
				</div>
			</div>
		</header>
	
			<!--BANNER START HERE-->
			<section class="hero" *ngIf="!showMenuComponent">
				<div class="container">
					<div class="hero-slider">
						<div class="hero-slider-info">
							<div class="hero-title">Lowest Prices Best Quality Shopping</div>
							<div class="hero-features">
								<div class="features-info">
									<div class="features-icn"><img src="./assets/images/video-icn.svg"></div>
									<div class="feature-tittle">Live Video Shopping</div>
								</div>
								<div class="features-info">
									<div class="features-icn"><img src="./assets/images/money-icn.svg"></div>
									<div class="feature-tittle">Cash on delivery</div>
								</div>
								<div class="features-info">
									<div class="features-icn"><img src="./assets/images/money-icn.svg"></div>
									<div class="feature-tittle">Easy exchange</div>
								</div>
								<div class="features-info">
									<div class="features-icn"><img src="./assets/images/money-icn.svg"></div>
									<div class="feature-tittle">Cash on delivery</div>
								</div>
							</div>
							<div class="social-links">
								<a href=""><img src="./assets/images/apple.svg"></a>
								<a href=""><img src="./assets/images/google.svg"></a>
							</div>
						</div>
						<div class="hero-slidera-img"> <img src="./assets/images/hero-img.png"> </div>
					</div>
				</div>
				<div class="hero-inner">
					<div class="hero-copy"> </div>
					<div class="hero-illustration">
						<div class="hero-shape hero-shape-1">
							<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">
								<circle class="anime-element fadeup-animation" cx="20" cy="20" r="20" fill="#FFD8CD" fill-rule="evenodd" /> </svg>
						</div>
						<div class="hero-main-shape">
							<svg width="940" height="647" viewBox="0 0 940 647" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="overflow:visible">
								<defs>
									<linearGradient x1="100%" y1="0%" x2="0%" y2="100%" id="hero-illustration-a">
										<stop stop-color="#037483" offset="0%" />
										<stop stop-color="#037483" offset="100%" /> </linearGradient>
									<linearGradient x1="89.764%" y1="16.809%" x2="11.987%" y2="82.178%" id="hero-illustration-b">
										<stop stop-color="#FC8464" offset="0%" />
										<stop stop-color="#FB5C32" offset="100%" /> </linearGradient>
									<linearGradient x1="100%" y1="23.096%" x2="4.439%" y2="96.586%" id="hero-illustration-c">
										<stop stop-color="#1ADAB7" offset="0%" />
										<stop stop-color="#55EBD0" offset="100%" /> </linearGradient>
									<filter x="-13%" y="-150%" width="126.1%" height="400%" filterUnits="objectBoundingBox" id="hero-illustration-d">
										<feGaussianBlur stdDeviation="32" in="SourceGraphic" /> </filter>
									<linearGradient x1="0%" y1="100%" x2="46.694%" y2="42.915%" id="hero-illustration-f">
										<stop stop-color="#EEF1FA" offset="0%" />
										<stop stop-color="#FFF" offset="100%" /> </linearGradient>
									<rect id="hero-illustration-e" width="800" height="450" rx="4" />
									<linearGradient x1="100%" y1="-12.816%" x2="0%" y2="-12.816%" id="hero-illustration-g">
										<stop stop-color="#D2DAF0" stop-opacity="0" offset="0%" />
										<stop stop-color="#D2DAF0" offset="50.045%" />
										<stop stop-color="#D2DAF0" stop-opacity="0" offset="100%" /> </linearGradient>
									<linearGradient x1="116.514%" y1="-21.201%" x2="0%" y2="100%" id="hero-illustration-h">
										<stop stop-color="#55EBD0" offset="0%" />
										<stop stop-color="#4950F6" offset="100%" /> </linearGradient>
									<path id="hero-illustration-j" d="M0 0h308v288H0z" />
									<filter x="-15.6%" y="-12.5%" width="139%" height="141.7%" filterUnits="objectBoundingBox" id="hero-illustration-i">
										<feOffset dx="12" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
										<feGaussianBlur stdDeviation="16" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
										<feColorMatrix values="0 0 0 0 0.0666666667 0 0 0 0 0.062745098 0 0 0 0 0.243137255 0 0 0 0.08 0" in="shadowBlurOuter1" /> </filter>
									<circle id="hero-illustration-k" cx="16" cy="16" r="16" />
									<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="hero-illustration-m">
										<stop stop-color="#C6FDF3" offset="0%" />
										<stop stop-color="#C6FDF3" stop-opacity="0" offset="100%" /> </linearGradient>
									<linearGradient x1="2.875%" y1="89.028%" x2="99.412%" y2="6.885%" id="hero-illustration-n">
										<stop stop-color="#83F0DD" offset="0%" />
										<stop stop-color="#1ADAB7" offset="50.924%" />
										<stop stop-color="#55EBD0" offset="100%" /> </linearGradient>
									<linearGradient x1="50%" y1="1.569%" x2="50%" y2="97.315%" id="hero-illustration-o">
										<stop stop-color="#FF97AA" offset="0%" />
										<stop stop-color="#FF6381" offset="100%" /> </linearGradient>
									<linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="hero-illustration-p">
										<stop stop-color="#FCAC96" offset="0%" />
										<stop stop-color="#FC8464" offset="100%" /> </linearGradient>
									<circle id="hero-illustration-r" cx="28" cy="28" r="28" />
									<filter x="-85.7%" y="-64.3%" width="314.3%" height="314.3%" filterUnits="objectBoundingBox" id="hero-illustration-q">
										<feOffset dx="12" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
										<feGaussianBlur stdDeviation="16" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
										<feColorMatrix values="0 0 0 0 0.0666666667 0 0 0 0 0.062745098 0 0 0 0 0.243137255 0 0 0 0.08 0" in="shadowBlurOuter1" /> </filter>
									<circle id="hero-illustration-t" cx="36" cy="36" r="36" />
									<filter x="-66.7%" y="-50%" width="266.7%" height="266.7%" filterUnits="objectBoundingBox" id="hero-illustration-s">
										<feOffset dx="12" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
										<feGaussianBlur stdDeviation="16" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
										<feColorMatrix values="0 0 0 0 0.0666666667 0 0 0 0 0.062745098 0 0 0 0 0.243137255 0 0 0 0.08 0" in="shadowBlurOuter1" /> </filter>
									<circle id="hero-illustration-v" cx="28" cy="28" r="28" />
									<filter x="-85.7%" y="-64.3%" width="314.3%" height="314.3%" filterUnits="objectBoundingBox" id="hero-illustration-u">
										<feOffset dx="12" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
										<feGaussianBlur stdDeviation="16" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
										<feColorMatrix values="0 0 0 0 0.0666666667 0 0 0 0 0.062745098 0 0 0 0 0.243137255 0 0 0 0.08 0" in="shadowBlurOuter1" /> </filter>
									<circle id="hero-illustration-x" cx="24" cy="24" r="24" />
									<filter x="-100%" y="-75%" width="350%" height="350%" filterUnits="objectBoundingBox" id="hero-illustration-w">
										<feOffset dx="12" dy="24" in="SourceAlpha" result="shadowOffsetOuter1" />
										<feGaussianBlur stdDeviation="16" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
										<feColorMatrix values="0 0 0 0 0.0666666667 0 0 0 0 0.062745098 0 0 0 0 0.243137255 0 0 0 0.08 0" in="shadowBlurOuter1" /> </filter>
								</defs>
								<g fill="none" fill-rule="evenodd">
									<path class="anime-element stroke-animation" d="M600,300 C600,465.685425 465.685425,600 300,600 C134.314575,600 1.3749042e-14,465.685425 3.60373576e-15,300 C-6.54157051e-15,134.314575 134.314575,-1.29473326e-14 300,-2.30926389e-14 C465.685425,-3.32379452e-14 600,134.314575 600,300 Z" fill="url(#hero-illustration-a)" stroke="#037483" />
									<g transform="translate(435 518)">
										<circle class="anime-element fadeup-animation" fill="url(#hero-illustration-b)" cx="106" cy="32" r="32" />
										<circle class="anime-element fadeup-animation" fill="url(#hero-illustration-c)" cx="12" cy="117" r="12" /> </g>
								</g>
							</svg>
						</div>
					</div>
				</div>
			</section>
		</div>
  

<router-outlet></router-outlet>
<!--FOOTER START HERE-->
<footer class="site-footer">
	<div class="container">
		<div class="site-footer-inner has-top-divider">
			<div class="brand footer-brand">
				<a href="#"> <img src="./assets/images/logo-footer.svg"> </a>
			</div>
			<ul class="footer-links list-reset">
				<li> <a [routerLink] = "['/terms-and-conditions']" >Terms and Conditions</a> </li>
				<li> <a href="#" >Contact</a> </li>
				<li> <a href="#">About us</a> </li>
				<li> <a href="#">FAQ's</a> </li>
				<li> <a href="#">Support</a> </li>
			</ul>
			<ul class="footer-social-links list-reset">
				<li>
					<a href="#"> <span class="screen-reader-text">Facebook</span>
						<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
							<path d="M6.023 16L6 9H3V6h3V4c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V6H13l-1 3H9.28v7H6.023z" fill="#FFF" /> </svg>
					</a>
				</li>
				<li>
					<a href="#"> <span class="screen-reader-text">Twitter</span>
						<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
							<path d="M16 3c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4C.7 7.7 1.8 9 3.3 9.3c-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H0c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4C15 4.3 15.6 3.7 16 3z" fill="#FFF" /> </svg>
					</a>
				</li>
				<li>
					<a href="#"> <span class="screen-reader-text">Google</span>
						<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.9 7v2.4H12c-.2 1-1.2 3-4 3-2.4 0-4.3-2-4.3-4.4 0-2.4 2-4.4 4.3-4.4 1.4 0 2.3.6 2.8 1.1l1.9-1.8C11.5 1.7 9.9 1 8 1 4.1 1 1 4.1 1 8s3.1 7 7 7c4 0 6.7-2.8 6.7-6.8 0-.5 0-.8-.1-1.2H7.9z" fill="#FFF" /> </svg>
					</a>
				</li>
			</ul>
			<div class="footer-copyright">&copy; 2020 Mantri's, all rights reserved</div>
		</div>
	</div>
</footer>